var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"bible-title",on:{"click":_vm.goToBible}},[_c('md-icon',[_vm._v("arrow_back")]),_vm._v(" "+_vm._s(_vm.booksName(_vm.$route.params.book, _vm.exhibitionType))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }